import { NavInternalMobile } from 'application/components/building_blocks/nav_internal'
import React from 'react'

const NavigationLinkMobile = () => {
    return <NavInternalMobile />
}

export default NavigationLinkMobile
